import MentionPluginDataProvider from '../providers/MentionPluginDataProvider';
import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import ScrollAdapter from 'owa-scroll-adapter/lib/ScrollAdapter';
import { PickerPluginOptions } from 'roosterjs-plugin-picker/lib/PickerDataProvider';
import EditorPickerPlugin from 'roosterjs-plugin-picker/lib/PickerPlugin';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';

export default class AtMentionPickerPlugin extends EditorPickerPlugin<MentionPluginDataProvider> {
    constructor(
        viewState: AtMentionsViewState,
        scrollAdapter: ScrollAdapter,
        targetRecipientWell: RecipientWellWithFindControlViewState,
        onRecipientAdded: () => void,
        canModifyRecipients: boolean,
        getAllRecipients: () => ReadWriteRecipientViewState[],
        pickerOptions: PickerPluginOptions
    ) {
        const provider = new MentionPluginDataProvider(
            viewState,
            scrollAdapter,
            targetRecipientWell,
            onRecipientAdded,
            canModifyRecipients,
            getAllRecipients
        );
        super(provider, pickerOptions);
    }

    public getName() {
        return 'AtMentionsPicker';
    }
}
